import { render, staticRenderFns } from "./AmountOrdersChart.vue?vue&type=template&id=13f10605&scoped=true&"
import script from "./AmountOrdersChart.vue?vue&type=script&lang=js&"
export * from "./AmountOrdersChart.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/widgets.css?vue&type=style&index=0&id=13f10605&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f10605",
  null
  
)

export default component.exports